// extracted by mini-css-extract-plugin
module.exports = {"banner":"title-module--banner--38S82","underline":"title-module--underline--3X2b1"};